import { useEffect } from 'react';
import { Control, FieldValues, useFieldArray } from 'react-hook-form';

type Props = {
  name: string;
  items: Record<string, { value?: unknown }>;
  control: Control<FieldValues>;
};

export const useDynamicFields = ({ name, items, control }: Props) => {
  const { fields, append, remove } = useFieldArray({ name, control });

  useEffect(() => {
    if (!fields.length) handleAdd();
  }, []);

  const handleAdd = () => {
    const itemFields = Object.entries(items).reduce(
      (acc, [key, question]) => {
        acc[key] = question.value;
        return acc;
      },
      {} as Record<string, unknown>,
    );
    append(itemFields, { shouldFocus: false });
  };

  return { fields, handleAdd, remove };
};
